export default __webpack_public_path__ + "static/media/mm.059173df.svg";